import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { from, Observable } from 'rxjs';
import { loadTranslation } from '@bpp-stella/common/i18n/translations';

/* Translations are bundled from bpp-stella-common (one lazy chunk per language);
   swappable to the backend /i18n/{lang}.json endpoint later without touching consumers. */
@Injectable({ providedIn: 'root' })
export class TranslocoBundleLoader implements TranslocoLoader {
  public getTranslation(lang: string): Observable<Translation> {
    return from(loadTranslation(lang));
  }
}
